<template>
  <div class="common-tree-box">
    <vue-easy-tree
      :itemSize="26"
      class="dialog-tree-small-primary"
      ref="bimElemTree"
      :data="bimElemTreeData"
      :props="defaultProps"
      :default-expanded-keys="['1']"
      node-key="uniqueId"
      highlight-current
      show-checkbox
      :expand-on-click-node="false"
      :check-strictly="isShowRvtGroup"
      @node-expand="handeNodeExpand"
      @node-click="handleNodeClick"
      @check="handleNodeCheck">
      <div
        slot-scope="{ data }"
        class="node-label"
        :dataNodeId="data.uniqueId">
        <div
          v-if="data.isRvtGroup"
          class="rvt-group-label">
          <icon-svg
            size="20"
            class="icon"
            title="Group节点"
            icon-class="icon-group" />
          <div
            class="group-name text-overflow"
            :title="data.name">
            {{ data.name }}
          </div>
        </div>
        <div
          v-else
          :title="data.name"
          class="text-overflow">
          {{ data.name }}
        </div>
      </div>
    </vue-easy-tree>
  </div>
</template>

<script>
import vueEasyTree from '@wchbrad/vue-easy-tree'

import {
  focusToDataSet,
  showDataSet,
  hideDataSet,
  resetElemAttr,
  highLightElems,
  showElems,
  hideElems
} from '@/utils/engineUtils'

import {
  getProjectTreeSubNodes,
  getSharedProjectTreeSubNodes,
  getProjectTreeSubNodesByLazy,
  getSharedProjectTreeSubNodesByLazy,
  getBimElemTreeNodesByGroupService,
  getProjectTreeChildren,
  getSharedProjectTreeChildren,
  getProjectTreeChildrenByLazy,
  getSharedProjectTreeChildrenByLazy,
  getBimElemIdsByGroupService
} from '@/service/interface'

import {
  getSharedBimElemTreeNodesByGroupService,
  getSharedBimElemIdsByGroupService
} from '@/service/share/sceneShareInterface.js'

export default {
  data() {
    return {
      bimElemTreeData: [],
      defaultProps: {
        children: 'nodes',
        label: 'name'
      },
      originBimElemTreeRootData: [],
      defaultTreeData: [],
      rvtGroupTreeData: []
    }
  },
  props: {
    isShareDataSet: Boolean,
    dataSetId: String,
    isShowRvtGroup: Boolean,
    version: String,
    bimElemTreeRootData: Array
  },
  components: {
    vueEasyTree
  },
  watch: {
    isShowRvtGroup: function (newVal) {
      this.switchOrganizeDataMode(newVal)
    }
  },
  mounted() {
    if (this.bimElemTreeRootData.length) {
      this.initBimElemTreeData()
    }
  },
  methods: {
    initBimElemTreeData() {
      if (this.bimElemTreeData.length) return

      this.bimElemTreeData = this.bimElemTreeRootData
      // prettier-ignore
      this.originBimElemTreeRootData = JSON.parse(JSON.stringify(this.bimElemTreeRootData))

      this.$nextTick(() => {
        let defaultCheckedKeys = [this.bimElemTreeData[0].uniqueId]
        if (this.$refs.bimElemTree) {
          this.$refs.bimElemTree.setCheckedKeys(defaultCheckedKeys)
        }
      })
    },
    switchOrganizeDataMode(isShowRvtGroup) {
      // 恢复所有数据集的所有构件颜色和透明度
      resetElemAttr('', [])

      let expandKeys = []
      const domRef = this.$refs.bimElemTree
      const rootNode = this.bimElemTreeData[0]
      let fileNodes = []
      if (rootNode.formatType === 1) {
        fileNodes = [rootNode]
      } else {
        fileNodes = this.bimElemTreeData[0].nodes
      }
      // prettier-ignore
      const treeDataMap = isShowRvtGroup ? this.rvtGroupTreeData : this.defaultTreeData
      fileNodes.forEach(item => {
        const node = domRef.getNode(item.uniqueId)
        node.expanded = false
        setTimeout(() => {
          let find = treeDataMap.find(el => el.parentUniqueId === item.uniqueId)
          if (find) {
            item.nodes = find.nodes
            expandKeys.push(item.uniqueId)
          } else {
            item.nodes = [{ name: '' }]
          }

          if (isShowRvtGroup && !item.hasRvtGroup) {
            item.nodes = []
          }
        }, 500)
      })

      this.$nextTick(() => {
        expandKeys.forEach(item => {
          const node = domRef.getNode(item)
          node.expanded = true
        })

        const rootNode = this.bimElemTreeData[0]
        let checkedKeys = []
        if (isShowRvtGroup) {
          checkedKeys = this.getAllChildFieldValues([rootNode], 'uniqueId')
        } else {
          checkedKeys = [rootNode.uniqueId]
        }

        domRef.setCheckedKeys(checkedKeys)
      })
    },
    handeNodeExpand(nodeData, node) {
      if (this.isShowRvtGroup) {
        if (!this.isRvtGroupNode(node)) {
          node.expanded = false
          node.loading = true
          nodeData.nodes = []
          node.expanded = true
          node.loading = false
          return
        }
        this.expandNodeByRvtGroup(nodeData, node)
      } else {
        this.expandNodeByDefault(nodeData, node)
      }
    },
    async handleNodeClick(nodeData, node) {
      if (nodeData.customNodeType === 'dataSet') {
        const dataSetId = this.dataSetId.replaceAll('-', '')
        focusToDataSet(dataSetId)
        return
      }

      if (nodeData.customNodeType === 'file') {
        const childNodeIds = await this.getElemIdsByDefaultNode(nodeData)
        if (childNodeIds.length) {
          const dataSetId = this.dataSetId.replaceAll('-', '')
          highLightElems(dataSetId, childNodeIds, true)
        }
        return
      }

      if (this.isShowRvtGroup) {
        const childNodeIds = await this.getElemIdsByRvtGroupNode(nodeData, node)
        if (childNodeIds.length) {
          const dataSetId = this.dataSetId.replaceAll('-', '')
          highLightElems(dataSetId, childNodeIds, true)
        }
      } else {
        const childNodeIds = await this.getElemIdsByDefaultNode(nodeData)
        if (childNodeIds.length) {
          const dataSetId = this.dataSetId.replaceAll('-', '')
          highLightElems(dataSetId, childNodeIds, true)
        }
      }
    },
    async handleNodeCheck(nodeData) {
      const node = this.$refs.bimElemTree.getNode(nodeData.uniqueId)

      // 如果操作对象为数据集
      if (nodeData.customNodeType === 'dataSet') {
        const dataSetId = this.dataSetId.replaceAll('-', '')
        const dataSetType = nodeData.dataSetType
        if (!node.checked) {
          hideDataSet(dataSetId, dataSetType)
        } else {
          showDataSet(dataSetId, dataSetType, true)
        }

        if (this.isShowRvtGroup) {
          this.setChildNodesCheckStatus(nodeData.nodes, node.checked)
        }
        return
      }

      if (nodeData.customNodeType === 'file') {
        const elemIds = await this.getElemIdsByDefaultNode(nodeData)
        if (!node.checked) {
          if (elemIds.length) {
            const dataSetId = this.dataSetId.replaceAll('-', '')
            hideElems(dataSetId, elemIds)
          }
        } else {
          if (elemIds.length) {
            const dataSetId = this.dataSetId.replaceAll('-', '')
            showElems(dataSetId, elemIds)
          }
        }

        if (this.isShowRvtGroup) {
          this.setChildNodesCheckStatus(nodeData.nodes, node.checked)
        }
        return
      }

      if (this.isShowRvtGroup) {
        const elemIds = await this.getElemIdsByRvtGroupNode(nodeData, node)
        if (!node.checked) {
          if (elemIds.length) {
            const dataSetId = this.dataSetId.replaceAll('-', '')
            hideElems(dataSetId, elemIds)
          }
        } else {
          if (elemIds.length) {
            const dataSetId = this.dataSetId.replaceAll('-', '')
            showElems(dataSetId, elemIds)
          }
        }

        this.setChildNodesCheckStatus(nodeData.nodes, node.checked)
      } else {
        const elemIds = await this.getElemIdsByDefaultNode(nodeData)
        if (!node.checked) {
          if (elemIds.length) {
            const dataSetId = this.dataSetId.replaceAll('-', '')
            hideElems(dataSetId, elemIds)
          }
        } else {
          if (elemIds.length) {
            const dataSetId = this.dataSetId.replaceAll('-', '')
            showElems(dataSetId, elemIds)
          }
        }
      }
    },
    setChildNodesCheckStatus(nodes, isChecked) {
      const childNodeKeys = this.getAllChildFieldValues(nodes, 'uniqueId')
      childNodeKeys.forEach(key => {
        const node = this.$refs.bimElemTree.getNode(key)
        if (node) {
          node.checked = isChecked
        }
      })
    },
    expandNodeByRvtGroup(nodeData, node) {
      if (this.isNodeExpanded(nodeData)) {
        if (node.checked) {
          node.childNodes.forEach(item => {
            item.checked = true
          })
        }
        return
      }

      this.loadRvtGroupNodes(nodeData, node)
    },
    async loadRvtGroupNodes(nodeData, node) {
      node.expanded = false
      node.loading = true

      let params = {
        dataSetId: this.dataSetId,
        fileIntId: nodeData.fileIntId,
        uniqueId: nodeData.uniqueId,
        version: this.version
      }

      let response
      if (this.isShareDataSet) {
        const headers = this.getHeaders()
        // prettier-ignore
        response = await getSharedBimElemTreeNodesByGroupService(params, headers)
      } else {
        response = await getBimElemTreeNodesByGroupService(params)
      }

      if (response.isSuccess) {
        nodeData.nodes = response.data
        let find = this.rvtGroupTreeData.find(item => {
          return item.uniqueId === nodeData.uniqueId
        })
        if (!find) {
          let obj = {
            parentUniqueId: nodeData.uniqueId,
            nodes: response.data
          }
          this.rvtGroupTreeData.push(obj)
        }
        this.$nextTick(() => {
          if (node.checked) {
            node.childNodes.forEach(item => {
              item.checked = true
            })
          }
          node.expanded = true
          node.loading = false
        })
      } else {
        this.$message.error(response.errMsg)
      }
    },
    expandNodeByDefault(nodeData, node) {
      if (this.isNodeExpanded(nodeData)) {
        if (node.checked) {
          node.childNodes.forEach(item => {
            item.checked = true
          })
        }
        return
      }

      let enableLazyLoading = nodeData.enableLazyLoading
      if (enableLazyLoading) {
        this.loadDefaultNodesByLazy(nodeData, node)
      } else {
        this.loadDefaultNodes(nodeData, node)
      }
    },
    async loadDefaultNodes(nodeData, node) {
      node.expanded = false
      node.loading = true

      let params = {
        dataSetId: this.dataSetId,
        fileIntId: nodeData.fileIntId,
        uniqueId: nodeData.uniqueId,
        version: this.version
      }
      let response = []
      if (this.isShareDataSet) {
        const headers = this.getHeaders()
        response = await getSharedProjectTreeSubNodes(params, { headers })
      } else {
        response = await getProjectTreeSubNodes(params)
      }

      if (response.isSuccess) {
        nodeData.nodes = response.data
        let find = this.defaultTreeData.find(item => {
          return item.uniqueId === nodeData.uniqueId
        })
        if (!find) {
          let obj = {
            parentUniqueId: nodeData.uniqueId,
            nodes: response.data
          }
          this.defaultTreeData.push(obj)
        }
        this.$nextTick(() => {
          if (node.checked) {
            node.childNodes.forEach(item => {
              item.checked = true
            })
          }
          node.expanded = true
          node.loading = false
        })
      }
    },
    async loadDefaultNodesByLazy(nodeData, node) {
      node.expanded = false
      node.loading = true

      let params = {
        dataSetId: this.dataSetId,
        parentNodeIntId: nodeData.nodeIntId
          ? Number(nodeData.nodeIntId)
          : Number(nodeData.fileIntId),
        hostFileId: Number(nodeData.fileIntId),
        version: this.version
      }
      let response = []
      if (this.isShareDataSet) {
        const headers = this.getHeaders()
        response = await getSharedProjectTreeSubNodesByLazy(params, { headers })
      } else {
        response = await getProjectTreeSubNodesByLazy(params)
      }

      if (response.isSuccess) {
        nodeData.nodes = response.data.map(item => {
          item['fileIntId'] = nodeData.fileIntId
          item['uniqueId'] = item.levelCode
          item['name'] = item.nodeName
          item['enableLazyLoading'] = true
          item.nodes = [{ name: '' }]
          return item
        })

        this.$nextTick(() => {
          if (node.checked) {
            node.childNodes.forEach(item => {
              item.checked = true
            })
          }

          node.expanded = true
          node.loading = false
        })
      } else {
        this.$message.error(response.errMsg)
      }
    },
    getQueryRvtGroupElemIdParams(nodes, node) {
      let childNodeId = this.getAllChildFieldValues(nodes, 'nodeId')
      const fileNodeData = this.findFileNodeData(node)
      let params = {
        dataSetId: this.dataSetId,
        hostFileId: fileNodeData.fileIntId,
        childNodeId,
        version: this.version
      }
      return params
    },
    getQueryDefaultElemIdParams(nodeData) {
      if (nodeData.customNodeType === 'file') {
        let params = {
          dataSets: [
            {
              dataSetId: this.dataSetId,
              hostFileId: nodeData.fileIntId
            }
          ],
          version: this.version
        }
        return params
      }

      let childNodeIds = this.getAllChildFieldValues([nodeData], 'nodeId')
      let dataSets = childNodeIds.map(item => {
        let obj = {
          dataSetId: this.dataSetId,
          childNodeId: item
        }
        return obj
      })
      let params = { dataSets, version: this.version }
      return params
    },
    async getElemIdsByDefaultNode(nodeData) {
      if (nodeData.enableLazyLoading) {
        let params = {
          dataSetId: this.dataSetId,
          hostFileId: Number(nodeData.fileIntId),
          levelCode: nodeData.levelCode ? nodeData.levelCode : undefined,
          version: this.version
        }

        let response = []
        if (this.isShareDataSet) {
          const headers = this.getHeaders()
          // prettier-ignore
          response = await getSharedProjectTreeChildrenByLazy(params, { headers })
        } else {
          response = await getProjectTreeChildrenByLazy(params)
        }

        if (response.isSuccess) {
          let childNodeIds = response.data
          return childNodeIds
        } else {
          this.$message.error(response.errMsg)
        }
      } else {
        let params = this.getQueryDefaultElemIdParams(nodeData)

        let response = []
        if (this.isShareDataSet) {
          const headers = this.getHeaders()
          response = await getSharedProjectTreeChildren(params, { headers })
        } else {
          response = await getProjectTreeChildren(params)
        }

        if (response.isSuccess) {
          let dataSets = response.data
          let childNodeIds = dataSets[0].childNodeIds
          return childNodeIds
        } else {
          this.$message.error(response.errMsg)
        }
      }
    },
    async getElemIdsByRvtGroupNode(nodeData, node) {
      let params = this.getQueryRvtGroupElemIdParams([nodeData], node)

      let response = []
      if (this.isShareDataSet) {
        const headers = this.getHeaders()
        response = await getSharedBimElemIdsByGroupService(params, headers)
      } else {
        response = await getBimElemIdsByGroupService(params)
      }
      if (response.isSuccess) {
        let data = response.data
        let childNodeIds = data.childNodeIds
        return childNodeIds
      } else {
        this.$message.error(response.message)
      }
    },
    isRvtGroupNode(node) {
      const fileNodeData = this.findFileNodeData(node)
      return fileNodeData.hasRvtGroup
    },
    getAllChildFieldValues(nodes, field) {
      let fieldArray = []
      const recursion = item => {
        if (item[field]) {
          fieldArray.push(item[field])
        }
        if (item.nodes && item.nodes.length) {
          item.nodes.forEach(node => {
            recursion(node)
          })
        }
      }
      nodes.forEach(item => {
        recursion(item)
      })

      return fieldArray
    },
    findFileNodeData(node) {
      const nodeData = node.data
      if (nodeData.formatType === 1) return nodeData
      if (nodeData.customNodeType === 'file') return nodeData

      if (node.parent) {
        return this.findFileNodeData(node.parent)
      }
    },
    isNodeExpanded(nodeData) {
      return nodeData.nodes[0]?.uniqueId
    },
    getHeaders() {
      let token = this.$route.query.token
      let headers = {
        Authorization: token
      }
      return headers
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';

.common-tree-box {
  .node-label {
    font-size: 14px;
    overflow: hidden;

    .rvt-group-label {
      display: flex;
      align-items: center;
      .icon {
        margin-right: 4px;

        :deep(.svg-icon) {
          use {
            color: var(--bimview-rvt-group-color) !important;
          }
        }
      }

      .group-name {
        color: var(--bimview-rvt-group-color) !important;
      }
    }
  }
}
</style>
